import EventApi from '@apis/event/EventApi';
import eventQueries from '@apis/queries/eventQueries';
import { GetEventsParams } from '@models/event/request';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getNextPageParam } from '@utils/pageable';

const HIDDEN_IDS = [
    // 사브올데이 배달 QR쿠폰 지류 쿠폰 발급 이벤트
    '0rrwpe6p3cszx',
    '0rrwp7aesvv38',
    '0rrwnzvp0evy3',
    '0rrwnqjrkcn15',
    '0rrwnecsdvp4f',
    '0rzwk7ws5b0vs',
    '0rzwjzrqamr3p',
    '0rzwjqej6mmch',
    '0rzwjdg4haqb3',
    '0rzwj0g7zkrdf',
];

function useEvents() {
    const params: Omit<GetEventsParams, 'page'> = {
        sorter: 'CreatedAtDesc', size: 10,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: eventQueries.list(params).queryKey,
        queryFn: ({ pageParam }) => EventApi.getEvents({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });

    const events = getFlattenPageResponse(queryInfo)
        ?.filter((it) => !HIDDEN_IDS.includes(it.id));
    const isBlank = queryInfo.isFetched && events?.length === 0;

    return {
        ...queryInfo,
        events,
        isBlank,
    };
}

export default useEvents;
